import { CheckCircleFilled } from '@ant-design/icons';
import { Card, Col, Row } from 'antd';
import styled from 'styled-components';

export const Container = styled(Row)`
  margin: 12px;
`;

export const MapCol = styled(Col)`
  margin-left: 12px;
  height: calc(100vh - 165px);
`;

export const ResourcesCol = styled(Col)`
  margin-left: 12px;
  height: calc(100vh - 165px);
  overflow: auto;
`;

export const MessageCard = styled(Card)`
  position: absolute;
  top: 76px;
  left: 55px;
  z-index: 400;
`;

export const CheckIcon = styled(CheckCircleFilled)`
  color: ${p => p.theme.success};
  margin-right: 9px;
`;

export const LeftCol = styled(Col)`
  max-height: calc(100vh - 165px);
  overflow: auto;
`;
